@file:OptIn(InternalResourceApi::class)

package fr.frux.app.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.app.resources/"

@delegate:ResourceContentHash(1_184_260_756)
internal val Res.string.userprofile_harvests_organized_singular: StringResource by lazy {
      StringResource("string:userprofile_harvests_organized_singular", "userprofile_harvests_organized_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14249, 75),
      ))
    }

@delegate:ResourceContentHash(792_057_758)
internal val Res.string.userprofile_member_since: StringResource by lazy {
      StringResource("string:userprofile_member_since", "userprofile_member_since", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14325, 56),
      ))
    }

@delegate:ResourceContentHash(-1_523_942_081)
internal val Res.string.userprofile_more_actions: StringResource by lazy {
      StringResource("string:userprofile_more_actions", "userprofile_more_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14382, 52),
      ))
    }

@delegate:ResourceContentHash(-478_899_239)
internal val Res.string.userprofile_title_fallback: StringResource by lazy {
      StringResource("string:userprofile_title_fallback", "userprofile_title_fallback", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14435, 42),
      ))
    }

@delegate:ResourceContentHash(-914_280_595)
internal val Res.string.userprofile_trees_added_plural: StringResource by lazy {
      StringResource("string:userprofile_trees_added_plural", "userprofile_trees_added_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14478, 58),
      ))
    }

@delegate:ResourceContentHash(1_768_479_362)
internal val Res.string.userprofile_trees_added_singular: StringResource by lazy {
      StringResource("string:userprofile_trees_added_singular", "userprofile_trees_added_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14537, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("userprofile_harvests_organized_singular", Res.string.userprofile_harvests_organized_singular)
  map.put("userprofile_member_since", Res.string.userprofile_member_since)
  map.put("userprofile_more_actions", Res.string.userprofile_more_actions)
  map.put("userprofile_title_fallback", Res.string.userprofile_title_fallback)
  map.put("userprofile_trees_added_plural", Res.string.userprofile_trees_added_plural)
  map.put("userprofile_trees_added_singular", Res.string.userprofile_trees_added_singular)
}
